// removed by extract-text-webpack-plugin
module.exports = {"footer-phone-number":"app-components-Sidebar-__style___2q2PP","business-name":"app-components-Sidebar-__style___wZH87"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Sidebar/style.css
// module id = 2215
// module chunks = 0